package ui.home.components

import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun NavSidebarProfile(
    getProfile: State<ProfileModel>,
    logout: () -> Unit,
    modifier: Modifier,
) {
    var isSelectProfileExpanded by remember {
        mutableStateOf(false)
    }

    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier,
    ) {
        Box(
            modifier = Modifier
                .padding(horizontal = 1.spacing),
        ) {
            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier.size(40.dp).border(
                    width = 1.dp,
                    color = Color(0xFF3a88fe),
                    shape = CircleShape,
                ).clip(CircleShape).clickable {
                    isSelectProfileExpanded = true
                },
            ) {
                if (getProfile.isLoading) EsSpinner()
                else Text(
                    text = getProfile.data?.initials ?: "",
                    color = Color(0xFF3a88fe),
                    style = MaterialTheme.esTypography.p2Medium14,
                    maxLines = 1,
                )
            }

            EsDropDownMenu(
                expanded = isSelectProfileExpanded,
                onDismissRequest = {
                    isSelectProfileExpanded = false
                },
                modifier = Modifier.width(200.dp),
            ) {
                if (getProfile.isLoading) EsSpinner(
                    modifier = Modifier.align(Alignment.CenterHorizontally).padding(16.dp),
                )
                else if (getProfile.isFailure) Text(
                    text = "Failed to load users",
                    style = MaterialTheme.esTypography.p2Medium14,
                    modifier = Modifier.padding(16.dp),
                )
                else {
                    EsDropdownMenuItem(
                        text = getProfile.data?.let { profile ->
                            profile.firstName + " " + profile.lastName
                        } ?: "X",
                        onClick = {
                            isSelectProfileExpanded = false
                        },
                    )

                    EsDropdownMenuItem(
                        text = "Logout",
                        textColor = MaterialTheme.esColorScheme.textError,
                        onClick = {
                            logout()
                            isSelectProfileExpanded = false
                        },
                    )
                }
            }
        }

        getProfile.data?.appVersion?.let {
            Text(
                text = "v $it",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p2Medium14,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier
                    .padding(vertical = 1.spacing),
            )
        }
    }
}